<!-- event Head -->
<div class="event-header" style="background-image: url(assets/image/Group-1896.png)">
  <div class="event-heading">
    <div class="event-head">
      <h3>DONATIONS</h3>
    </div>
  </div>
</div>
<!-- donation details -->
<div class="donation-container">
  <div class="detail-heading">
    <h4>The Antique Phonograph Society, a 501(c)(3) public charity, relies upon tax-deductible donations to continue to
      provide services to the phonograph hobby.</h4>
  </div>
  <div class="donation-details">
    <p>We provide outreach to communities, collectors and those interested in learning more about the history of
      recorded sound and the means to listen to it. We engage in and share original research, in both published form and
      at collector events. We are all unpaid volunteers who donate considerable time (and money) to share our knowledge.
      The Antique Phonograph Society does not charge for this outreach. Please consider supporting our hobby and efforts
      by volunteering and/or by making a tax-deductible financial donation.</p>
    <p>The Antique Phonograph Society (“APS”) is a non-profit organization pursuant to Section 501(c)(3) of the United
      States Internal Revenue Code. Your donation to APS may qualify for an income tax deduction in accordance with
      Federal and/or State income tax laws. Please consult with your tax advisor to determine whether your donation is
      tax deductible in whole or in part. Nothing in this communication is intended to constitute legal or tax advice.
    </p>
  </div>

  <div *ngIf="!donation; else elseBlock" class="form">
    <h3 style="text-align: center;margin-top: 3rem;">Make a Donation</h3>

    <div class="textbox-design">
      <label for="">Name <span>*</span></label>
      <input type="text" name="name" id="donnerName" class="formclass">
    </div>

    <div class="textbox-design">
      <label for="">Email <span>*</span></label>
      <input type="email" name="Email" id="donnerEmail" class="formclass">
    </div>

    <div class="textbox-design">
      <label for="">Description <span>*</span></label>
      <textarea name="description" id="description" class="formclass" cols="30" rows="5"
        placeholder="This payment is for all {{currentyear}} quarterly Journals"></textarea>
      <!-- <input type="textarea" name="Email" id="donnerEmail" class="formclass"> -->
    </div>
    <div class="textbox-design">
      <button class="btn donation-formbutton" (click)="submitdata()">Make Donation</button>
    </div>




  </div>
  <ng-template #elseBlock>
    <h3 style="text-align: center;margin-top: 3rem;">Complete the Donation</h3>
    <div class="don-btn-details">
      <!-- <a href="#"  class="don-btn">DONATE</a> -->

      <form #form action="https://www.paypal.com/cgi-bin/webscr" method="post">
        <input type="hidden" name="cmd" value="_s-xclick">
        <input type="hidden" name="hosted_button_id" value="F2SAPVXRXK3FS">
        <!-- <input type="image" src="https://www.paypalobjects.com/en_US/i/btn/btn_donateCC_LG.gif" border="0" name="submit" alt="PayPal - The safer, easier way to pay online!"> -->
        <!-- <input type="submit"   class="don-btn" (click)="form.submit()" value="DONATE"> -->
        <input type="submit" class="don-btn" (click)="form.submit()" value="Click here to Pay">

      </form>
      <!-- <input type="button" value="test" (click)="onclick()"> -->

    </div>

  </ng-template>
  <div class="donation-not">
    <!-- <p> This payment is for all {{currentyear}} quarterly Journals</p> -->
  </div>
</div>